export { default as MarketingHero } from './MarketingHero';
